import * as types from "./actionTypes";

export const getRequest = (id) => {
  return {
    type: types.FEEDBACK_SHOW_REQUEST,
    id
  };
};
export const getSuccess = (id, data) => {
  return {
    type: types.FEEDBACK_SHOW_SUCCESS,
    payLoad: {id, data}
  };
};
export const getFailure = (id, data) => {
  return {
    type: types.FEEDBACK_SHOW_FAILURE,
    payLoad: {id, data}
  };
};

export const readRequest = id => {
  return {
    type: types.FEEDBACK_READ_REQUEST,
    id
  };
};
export const readSuccess = data => {
  return {
    type: types.FEEDBACK_READ_SUCCESS,
    payLoad: data
  };
};
export const readFailure = () => {
  return {
    type: types.FEEDBACK_READ_FAILURE
  };
};

export const getListRequest = () => {
  return {
    type: types.FEEDBACK_LIST_REQUEST
  };
};
export const getListSuccess = data => {
  return {
    type: types.FEEDBACK_LIST_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = () => {
  return {
    type: types.FEEDBACK_LIST_FAILURE
  };
};

export const storeRequest = data => {
  return {
    type: types.FEEDBACK_STORE_REQUEST,
    data: data
  };
};
export const storeSuccess = data => {
  return {
    type: types.FEEDBACK_STORE_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.FEEDBACK_STORE_FAILURE
  };
};

export const titlesRequest = () => {
  return {
    type: types.FEEDBACK_TITLES_REQUEST
  };
};
export const titlesSuccess = data => {
  return {
    type: types.FEEDBACK_TITLES_SUCCESS,
    payLoad: data
  };
};
export const titlesFailure = () => {
  return {
    type: types.FEEDBACK_TITLES_FAILURE
  };
};

export const ScoreRequest = (id, score) => {
  return {
    type: types.FEEDBACK_SCORE_REQUEST,
    id,
    score
  };
};
export const ScoreSuccess = data => {
  return {
    type: types.FEEDBACK_SCORE_SUCCESS,
    payLoad: data
  };
};
export const ScoreFailure = () => {
  return {
    type: types.FEEDBACK_SCORE_FAILURE
  };
};


export const modalData = data => {
  return {
    type: types.FEEDBACK_MODAL_DATA,
    data
  };
};
export const closeModal = () => {
  return {
    type: types.FEEDBACK_CLOSE_MODAL
  };
};